//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.DrawingRegionRulesBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"DrawingRegionRulesBuilder",0,"Drawings.DrawingRegionRulesBuilder",0],[0,"Gap",1,0],[0,"GrowthDirection",1,0],[1,"Height",0,"Expression",0],[0,"HorizontalGrowthDirection",1,0],[1,"Length",0,"Expression",0],[0,"MoveContent",1,0],[0,"Name",1,0],[0,"ObjectType",1,0],[0,"Origin",1,"Point",0],[0,"Priority",1,0],[0,"SpecifyContinuation",1,0],[0,"VerticalGrowthDirection",1,0]],[[["nextLinkedRegion"],"SetNextLinkedRegion",{},1,0]],[]];
SPLM.Drawings.DrawingRegionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DrawingRegionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DrawingRegionBuilder.RegionDraftingObjectType = Object.freeze({
    "View" : "View", "Table" : "Table", "Annotation" : "Annotation", "Symbol" : "Symbol", "Blank" : "Blank", "None" : "None"});

SPLM.Drawings.DrawingRegionBuilder.RegionContinuation = Object.freeze({
    "None" : "None", "NewSheet" : "NewSheet", "NextRegion" : "NextRegion", "NewSheetRight" : "NewSheetRight", "NewSheetLeft" : "NewSheetLeft", "NewSheetUp" : "NewSheetUp", "NewSheetDown" : "NewSheetDown"});

SPLM.Drawings.DrawingRegionBuilder.ContentToMove = Object.freeze({
    "All" : "All", "OnlyOverlapping" : "OnlyOverlapping"});

SPLM.Drawings.DrawingRegionBuilder.RegionVerticalGrowthDirection = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.Drawings.DrawingRegionBuilder.RegionHorizontalGrowthDirection = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Drawings.DrawingRegionBuilder.RegionGrowthDirection = Object.freeze({
    "RightfromTopLeft" : "RightfromTopLeft", "RightfromBottomLeft" : "RightfromBottomLeft", "LeftfromTopRight" : "LeftfromTopRight", "LeftfromBottomRight" : "LeftfromBottomRight", "DownfromTopLeft" : "DownfromTopLeft", "DownfromTopRight" : "DownfromTopRight", "UpfromBottomLeft" : "UpfromBottomLeft", "UpfromBottomRight" : "UpfromBottomRight", "None" : "None"});

export default SPLM;